app.service('subscriptionServices', function (loading, modal, subscriptionServiceInvoiceForm, subscriptionResignForm, ajaxErrorHandler) {

	let subscriptionServiceContractId;
	let subscriptionServiceName = '';

	function init() {

		setEvents();

		subscriptionServiceInvoiceForm.init({loadSubscriptionServiceDetails});
	}

	function setEvents() {
		$('body')
			.on('click', '.js-subscription-services-resign', handleSubscriptionContractResignClick)
			.on('click', '.js-subscription-services-details', handleSubscriptionServiceDetailsClick)
			.on('click', '#service-resign-modal .remodal-close', function () {
				sendUA("Przycisk X");
			});

		$(document)
			.on('closed', '#service-resign-modal', function (event, data) {
				if (data.reason && data.reason === 'outsideClick') {
					sendUA("Kliknięcie poza warstwę");
				}
			});
	}

	function handleSubscriptionContractResignClick() {

		subscriptionServiceContractId = $(this).data('id');
		subscriptionServiceName = $(this).data('name');

		loadSubscriptionContractResignForm();
	}

	function handleSubscriptionServiceDetailsClick() {

		const recurringPaymentId = $(this).data('recurring-payment-id');
		const nagId = $(this).data('nag-id');
		const pluList = $(this).data('plu-list');

		let $box = $(`.subscription-item[data-id="${recurringPaymentId}"]`);

		loadSubscriptionServiceDetails(recurringPaymentId, nagId, pluList)
			.then(html => {
				$('.subscription-item-details', $box).html(html);
			});
	}

	/**
	 * Doczytuje formularz z ankietą, który pozwala użytkownikowi podać powód rezygnacji z usługi
	 */
	function loadSubscriptionContractResignForm() {
		loading.start();

		$.ajax({
			url: "/customer-subscription-service-contract-close-reason.ltr",
			type: "GET",
			success(questionnaireHtml) {
				openModal(questionnaireHtml);
			},
			error: ajaxErrorHandler.createFailHandler('subscriptionServices.loadSubscriptionContractResignForm'),
			complete() {
				loading.stop();
			}
		});
	}

	function openModal(questionnaireHtml) {

		const content =
			`<p>Twoja rezygnacja z usługi ${subscriptionServiceName} wraz z usługą płatności cyklicznej jest nieodwracalna.</p>
			<p>Nie będziesz mógł ponownie aktywować tej usługi.</p>
			${questionnaireHtml}`;

		modal.generate({
			id: 'service-resign-modal',
			header: 'Rezygnacja z mikropłatności miesięcznej (subskrypcji)',
			content,
			buttons: [
				{
					text: "Wróć",
					cssClass: 'cancel-resignation',
					click: function () {
						modal.close();
						sendUA("Przycisk Wróć");
					}
				},
				{
					text: "Potwierdzam rezygnację",
					cssClass: 'confirm-resignation is-disabled',
					click: confirmSubscriptionContractResign
				}
			]
		});
	}

	/**
	 * Obsługa wysyłki ankiety po kliknięciu "Potwierdzam rezygnację"
	 */
	function confirmSubscriptionContractResign() {
		loading.start();

		const {closeReasonName, closeReasonDescription} = subscriptionResignForm.getResignFormData();

		$.ajax({
			url: '/customer-subscription-service-contract-close.ltr',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				subscriptionServiceContractId: subscriptionServiceContractId,
				closeReasonName,
				closeReasonDescription
			}),
			success: function (result) {
				if (result.status === 'SUCCESS') {
					window.location.hash = "uslugi";
					location.reload();
				} else {
					loading.stop();
					modal.alert(result.messages[0]);
				}
			},
			error: ajaxErrorHandler.createFailHandler('subscriptionServices.confirmSubscriptionContractResign'),
			complete() {
				loading.stop();
			}
		});
	}

	/**
	 * Doczytuje szczegółowe informacje o usługach wchodzących w skład recurringPaymentId
	 * @param recurringPaymentId
	 */
	function loadSubscriptionServiceDetails(recurringPaymentId, nagId, pluList) {
		loading.start();

		return $.ajax({
			url: `/customer-subscription-service-contract-details.ltr`,
			type: "GET",
			data: {
				recurringPaymentId,
				nagId,
				pluList
			}
		})
			.fail(ajaxErrorHandler.createFailHandler('subscriptionServices.loadSubscriptionServiceDetails'))
			.always(() => {
				loading.stop();
			});
	}

	function sendUA(reason) {
		UA.push({
			event: "visitorInteraction",
			eventCategory: "InsuranceQuestionnaire",
			eventAction: "Zamknięcie popupa",
			eventLabel: reason
		});
	}

	return {
		init,
		loadSubscriptionServiceDetails
	};
});